<script lang="ts" setup>
import {computed, onMounted, ref} from "vue";
import {reSendInvitation} from "@/services/quizService.ts";
import {useQuizStore} from "@/stores/quizStore.ts";

defineProps({
  isFetching: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['timerStart', 'end'])

const {token} = useQuizStore()

const duration = 30 // seconds
const timeLeft = ref(duration)
const timeoutCompleted = ref(false)
const isRunning = ref(false)

const formatedTimeLeft = computed(() => {
  const minutes = Math.floor(timeLeft.value / 60)
  const secs = timeLeft.value % 60
  return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
})

let timerId: number

function startTimer() {
  if (isRunning.value) return
  emit('timerStart')
  isRunning.value = true
  timeoutCompleted.value = false
  timeLeft.value = duration

  timerId = setInterval(() => {
    timeLeft.value--

    if (timeLeft.value <= 0) {
      clearInterval(timerId)
      timeoutCompleted.value = true
      isRunning.value = false
      emit('end')
    }
  }, 1000)
}

function resetTimer() {
  clearInterval(timerId)
  timeLeft.value = duration
  timeoutCompleted.value = false
  isRunning.value = false
}

function reSendVerification() {
  if (isRunning.value || !timeoutCompleted.value) return
  resetTimer()
  startTimer()
  reSendInvitation(token.value)
}

onMounted(() => {
  startTimer()
})
</script>

<template>
  <button :disabled="isRunning || isFetching"
          class="text-blue-600 cursor-pointer hover:text-blue-800 mb-4 disabled:text-gray-400 disabled:cursor-not-allowed"
          @click="reSendVerification">Resend verification <span
    v-if="timeLeft > 0">code in ({{ formatedTimeLeft }})</span>
  </button>
</template>
